<template>
    <div>
        <li class="header">NAVIGASI UTAMA</li>

                <li class="active">
                    <router-link to="/simpeg">
                        <i class="material-icons">home</i>
                        <span>Home</span>
                    </router-link>
                </li>
                <li v-if="cek_menu_Profil()">
                    <a href="javascript:void(0);" class="menu-toggle">
                        <i class="material-icons col-green">perm_contact_calendar</i>
                        <span>Profil Pegawai</span>
                    </a>
                    <ul class="ml-menu">
                        <li v-if="level_akses_simpeg.biodata_pegawai">
                            <router-link to="/simpeg_biodata">Biodata Pegawai</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.karpeg">
                            <router-link to="/simpeg_karpeg">Kartu Pegawai</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.skp">
                            <router-link to="/simpeg_skp">SKP Pegawai</router-link>
                        </li>

                        <li v-if="cek_sub_menu_kepangkatan_jabatan()">
                            <a href="javascript:void(0);" @click="hover_submenu('simpeg_kepangkatan_jabatan')">
                                <b>Riwayat Kepangkatan/Jabatan</b>
                                <div class="simpeg_kepangkatan_jabatan tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="simpeg_kepangkatan_jabatan">
                                <li v-if="level_akses_simpeg.sk_pengangkatan">
                                    <router-link to="/simpeg_riwayat_pengangkatan">SK-Pengangkatan</router-link>
                                </li>
                                <li v-if="level_akses_simpeg.sk_kepangkatan">
                                    <router-link to="/simpeg_riwayat_kepangkatan">Kepangkatan</router-link>
                                </li>
                                <li v-if="level_akses_simpeg.jabatan_struktural">
                                    <router-link to="/simpeg_riwayat_jabatan_struktural">Jabatan Struktural</router-link>
                                </li>
                                <li v-if="level_akses_simpeg.jabatan_fungsional">
                                    <router-link to="/simpeg_riwayat_jabatan_fungsional">Jabatan Fungsional</router-link>
                                </li>
                            </ul>
                        </li>

                        <li v-if="level_akses_simpeg.penghargaan">
                            <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Riwayat Penghargaan</a>
                        </li>
                        <li v-if="level_akses_simpeg.pengalaman">
                            <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Riwayat Pengalaman</a>
                        </li>
                        <li v-if="level_akses_simpeg.organisasi">
                            <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Riwayat Organisasi</a>
                        </li>
                        <li v-if="level_akses_simpeg.cuti">
                            <a @click="alertku('info', 'Page ini belum diaktifkan oleh Administrator!')">Riwayat Cuti</a>
                        </li>
                        <li v-if="cek_sub_menu_data_keluarga()">
                            <a href="javascript:void(0);" @click="hover_submenu('simpeg_data_keluarga')">
                                <b>Data Keluarga</b>
                                <div class="simpeg_data_keluarga tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="simpeg_data_keluarga">
                                <li v-if="level_akses_simpeg.karsi_karsu">
                                    <router-link to="/simpeg_data_suami_istri">Data Suami/Istri</router-link>
                                </li>
                                <li v-if="level_akses_simpeg.data_anak">
                                    <router-link to="/simpeg_data_anak">Data Anak</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="cek_menu_riwayat_pendidikan()">
                    <a href="javascript:void(0);" class="menu-toggle">
                        <i class="material-icons col-green">school</i>
                        <span>Riwayat Pendidikan</span>
                    </a>
                    <ul class="ml-menu">
                        <li v-if="level_akses_simpeg.pendidikan_formal">
                            <router-link to="/simpeg_pendidikan_formal">Riwayat Pendidikan Formal</router-link>
                        </li>
                        <!-- <li>
                            <router-link to="/simpeg_pendidikan_non_formal">Riwayat Pendidikan Non Formal</router-link>
                        </li> -->
                        <li v-if="level_akses_simpeg.diklat_fungsional">
                            <router-link to="/simpeg_diklat_fungsional">Riwayat Diklat Fungsional</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.diklat_struktural">
                            <router-link to="/simpeg_diklat_struktural">Riwayat Diklat Struktural</router-link>
                        </li>

                    </ul>
                </li>
             



    
                <li class="header">DATA MASTER</li>
                <li v-if="cek_menu_Master()">
                    <a href="javascript:void(0);" class="menu-toggle">
                        <i class="material-icons col-deep-orange">assignment_returned</i>
                        <span>Data Master</span>
                    </a>
                    <ul class="ml-menu">
                        <li v-if="level_akses_simpeg.instansi">
                            <router-link to="/simpeg_biodata">Master Instansi</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.unit_kerja">
                            <router-link to="/simpeg_biodata">Master Unit Kerja</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.jabatan">
                            <router-link to="/simpeg_jabatan">Master Jabatan</router-link>
                        </li>
                        <li v-if="level_akses_simpeg.jabatan">
                            <router-link to="/simpeg_golongan">Master Pangkat/Golongan</router-link>
                        </li>

                        
                        <!-- <li>
                            <router-link to="/office_borang_acu">Kepegawaian</router-link>
                        </li> -->

                    </ul>
                </li>
                

                <li>
                    <a href="javascript:void(0);">
                        <i class="material-icons col-amber">settings</i>
                        <span>Pengaturan</span>
                    </a>
                </li>

    </div>
</template>

<script>
const ADD_URL_LEVEL_SIMPEG = URL_APP + 'api/v1/reg_modul_simpeg/';
export default {
    data (){
        return{
            id_user : '',
            level_akses_simpeg : {
              
            }
        }
    },
    methods: {
        getLevelSimpeg : function(){
            fetch(ADD_URL_LEVEL_SIMPEG +'get_one',{
                method : 'POST',
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : 'id'
                })
            })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data);
                this.level_akses_simpeg = res_data;
                // localStorage.level = JSON.stringify(res_data);
                // console.log(this.level_akses_simpeg);
            });
        },
        cek_menu_Profil(){
            var data = this.level_akses_simpeg;
            if (
                data.biodata_pegawai == 0 &&
                data.karpeg == 0 &&
                data.skp == 0 &&
                data.penghargaan == 0 &&
                data.sk_pengangkatan == 0 &&
                data.sk_kepangkatan == 0 &&
                data.jabatan_struktural == 0 &&
                data.jabatan_fungsional == 0 &&
                data.penghargaan == 0 &&
                data.pengalaman == 0 &&
                data.organisasi == 0 &&
                data.cuti == 0 &&
                data.karsi_karsu == 0 &&
                // data.xxxx == 0 &&
                // data.xxxx == 0 &&
                // data.xxxx == 0 &&
                // data.xxxx == 0 &&
                // data.xxxx == 0 &&
                // data.xxxx == 0 &&
                data.data_anak == 0
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        cek_sub_menu_kepangkatan_jabatan(){
            var data = this.level_akses_simpeg;
            if (
                data.sk_pengangkatan == 0 &&
                data.sk_kepangkatan == 0 &&
                data.jabatan_struktural == 0 &&
                data.jabatan_fungsional == 0 
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        cek_sub_menu_data_keluarga(){
            var data = this.level_akses_simpeg;
            if (
                data.karsi_karsu == 0 &&
                data.data_anak == 0 
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        cek_menu_riwayat_pendidikan(){
            var data = this.level_akses_simpeg;
            if (
                data.pendidikan_formal == 0 &&
                data.diklat_fungsional == 0 &&
                data.diklat_struktural == 0
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        hover_submenu : function(data){

            if ($('#'+data+'').is(':visible')){
                $('#'+data+'').hide('');
                $('.'+data+'').empty();
                $('.'+data+'').append('<i class="material-icons icon_add">add</i>');
            }
            else{
                $('#'+data+'').show('');
                $('.'+data+'').empty();
                $('.'+data+'').append('<i class="material-icons icon_add">remove</i>');
            }

        },
        alertku : function(type, title){
            this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 1800
            });
        },
        cek_menu_Master(){
            var data = this.level_akses_simpeg;
            if (

                data.instansi == 0 &&
                data.unit_kerja == 0 &&
                data.jabatan == 0 
                ) 
            {
                return false;    
            } else {
                return true;
            }
        },
        
    },
    mounted() {

        var get_profile = JSON.parse(localStorage.profile);
        this.id_user = get_profile._id
        this.getLevelSimpeg();

    },

}
</script>

<style>

</style>
